import { __decorate } from "tslib";
import { DataObject, rawDataSymbol, rtfm } from '@twurple/common';
/**
 * A Twitch emote.
 */
let HelixEmote = class HelixEmote extends DataObject {
    /**
     * The ID of the emote.
     */
    get id() {
        return this[rawDataSymbol].id;
    }
    /**
     * The name of the emote.
     */
    get name() {
        return this[rawDataSymbol].name;
    }
    /**
     * Gets the URL of the emote image in the given scale.
     *
     * @param scale The scale of the image.
     */
    getImageUrl(scale) {
        return this[rawDataSymbol].images[`url_${scale}x`];
    }
};
HelixEmote = __decorate([
    rtfm('api', 'HelixEmote', 'id')
], HelixEmote);
export { HelixEmote };
